
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import BacButton from '@/components/BacButton.vue'

import sanitizeHtml from 'sanitize-html'
import { Rally } from '../../../lib/models/Rally'
import { RallyRound } from '../../../lib/models/RallyRound'

@Component({
  components: {
    BacButton
  }
})
export default class CrewTable extends Vue {
  @Prop({ default: '' }) title!: string
  @Prop({ default: () => [] }) items!: []
  @Prop({ default: false }) showRound!: boolean
  @Prop({ default: () => [], required: false }) rallies!: Rally[]

  sanitizeHtml = sanitizeHtml;

  editedCustomerId = -1;

  get headersWithPermissions () {
    const headers = this.headers

    if (this.showRound) {
      headers.splice(2, 0, { text: 'Rodeos', value: 'rodeos', width: 80 })
    }

    if (
      this.$store.state.LoggedInUser.user &&
      !this.$store.state.LoggedInUser.user.isAdmin
    ) {
      return headers
    }
    // special admin columns
    return [
      ...headers,
      { text: 'Berechtigungen', value: 'permissions', width: 30 }
    ]
  }

  headers = [
    { text: 'Name', value: 'name', width: 80 },
    { text: 'Tätigkeit', value: 'task', width: 30 },
    { text: 'E-Mail', value: 'email', width: 30 },
    { text: 'Telefonnummer', value: 'telephone', width: 30 },
    { text: 'Letzte T-shirtgröße', value: 'lastTShirtSize', width: 30 },
    { text: 'Geburtstag', value: 'birthday', width: 30 },
    { text: 'Sozialversicherung', value: 'socialSecurity', width: 30 },
    { text: 'IBAN', value: 'iban', width: 30 },
    { text: 'Adresse', value: 'address', width: 30 },
    { text: 'Passwort ändern', value: 'password', width: 30 },
    { text: 'Einsatzgebiet', value: 'operatingArea', width: 100 },
    { text: 'Mehr Infos', value: 'moreInfos', width: 30 }
  ];

  @Watch('editedCustomerId')
  onCustomerIdChange () {
    this.$emit('changeEditedCustomerId', this.editedCustomerId)
  }

  getRallyRoundNameById (id: number) {
    return RallyRound.getRallyRoundNameById(
      id,
      this.$store.state.Rally.rallies,
      this.$store.getters.rallyRounds
    )
  }
}

